import { render, staticRenderFns } from "./productInner.vue?vue&type=template&id=16c7e466&scoped=true"
import script from "./productInner.vue?vue&type=script&lang=js"
export * from "./productInner.vue?vue&type=script&lang=js"
import style0 from "./productInner.vue?vue&type=style&index=0&id=16c7e466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c7e466",
  null
  
)

export default component.exports